import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import GlassMenu from "../GlassMenu";
import NewHero from "../missionsplash";
import MissionStatement from "../missionstatement";
import Footer from "../footer";

export default function Manifesto() {
  const heroRef = useRef(null);
  const latchRef = useRef(null);

  const [latched, setLatched] = useState(false);

  useEffect(() => {
    const heroEl = heroRef.current;
    const latchEl = latchRef.current;
    if (!heroEl || !latchEl) return;

    const appearAfterVH = 1.15;

    let raf = 0;
    let latchY = 0;

    const computeLatchY = () => {
      const heroRect = heroEl.getBoundingClientRect();
      const heroBottomDocY = window.scrollY + heroRect.bottom;
      const placeholderDocY = heroBottomDocY + window.innerHeight * appearAfterVH;
      const ph = latchEl.getBoundingClientRect().height || 44;

      latchY = placeholderDocY - (window.innerHeight - 24 - ph);
    };

    const update = () => {
      raf = 0;
      setLatched(window.scrollY >= latchY);
    };

    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    const handleResize = () => {
      computeLatchY();
      schedule();
    };

    const handleLoad = () => {
      computeLatchY();
      schedule();
    };

    computeLatchY();
    update();

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleLoad);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="Homepage" style={{ backgroundColor: "#5FBA8B" }}>
      <Helmet>
        <title>Commonwealth | Manifesto</title>
      </Helmet>

      <div ref={heroRef}>
        <NewHero />
      </div>

      <div
        ref={latchRef}
        style={{
          height: "1px",
          width: "1px",
          opacity: 0,
          pointerEvents: "none",
        }}
      />

      <MissionStatement />

      <div className="glassMenuDock">
        <GlassMenu visible={latched} />
      </div>

      <Footer />
    </div>
  );
}
